import requests from "./httpService";

// Offline query tickets (chat admin). Login required; the server decides what
// each user may see and do (Admin: all + assign/reject; employee: own + resolve).
const OfflineServices = {
  getAllOfflineQuery: async () => {
    return requests.get("/getAllOfflineQquery");
  },
  getOfflineQuery: async (id) => {
    return requests.get(`/offlinequery/${id}`);
  },
  assignOfflineQuery: async (id, employeeId) => {
    return requests.put(`/offlinequery/assign/${id}`, { employee_id: employeeId });
  },
  rejectOfflineQuery: async (id, reason) => {
    return requests.put(`/offlinequery/reject/${id}`, { reason });
  },
  // Save the answer; the ticket stays assigned until it is resolved.
  replyOfflineQuery: async (id, resolution) => {
    return requests.put(`/offlinequery/reply/${id}`, { resolution });
  },
  // Close the ticket, with the answer typed now or the one already saved.
  resolveOfflineQuery: async (id, resolution) => {
    return requests.put(`/offlinequery/resolve/${id}`, { resolution: resolution || "" });
  },
};

export default OfflineServices;
